document.addEventListener('DOMContentLoaded', () => {

  const NOTIFY_SHEET_URL = 'https://script.google.com/macros/s/AKfycbyiopDUc8W76u_i0jutMye2_QnTMn0YyaPUwK2faGx2QEderjDqUOPTuUgogZ4kclIs/exec';

  const notifyOverlay = document.querySelector('.notify-overlay');
  const notifyDrawer = document.getElementById('notify-drawer');
  const notifyCloseBtn = notifyDrawer?.querySelector('.notify-close-btn');
  const submitBtn = notifyDrawer?.querySelector('.notify-email-submit:not(.continueBtn)');
  const addtocartbtn = document.querySelector('.product-form__submit');
  const continueBtn = notifyDrawer?.querySelector('.continueBtn');
  const emailWrapper = notifyDrawer?.querySelector('.notify-email-wrapper');
  const thankuWrapper = notifyDrawer?.querySelector('.notify-thanku-wrapper');
  const emailInput = notifyDrawer?.querySelector('input[name="email"]');
  const notifyMeBtn = document.querySelector('.notify-me-btn');
  let currentVariant = null;

  // Inject error message element after the input
  const emailError = document.createElement('p');
  emailError.style.cssText = 'color: red; font-size: 13px; margin: -6px 0 10px; display: none;';
  emailError.textContent = 'Please enter a valid email address.';
  emailInput?.insertAdjacentElement('afterend', emailError);

  function showError() {
    emailError.style.display = 'block';
    emailInput.style.borderColor = 'red';
  }

  function hideError() {
    emailError.style.display = 'none';
    emailInput.style.borderColor = '#D9D9D9';
  }

  function openDrawer() {
    const raw = notifyMeBtn?.dataset?.variant;
      if (raw) {
        try { currentVariant = JSON.parse(raw); } catch {}
      }

    notifyOverlay?.classList.add('is-open');
    notifyDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    notifyOverlay?.classList.remove('is-open');
    notifyDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
    emailWrapper.style.display = 'block';
    thankuWrapper.style.display = 'none';
    if (emailInput) emailInput.value = '';
    hideError();
    submitBtn.textContent = 'Notify Me';
    submitBtn.disabled = false;
  }

  // Clear error as user types
  emailInput?.addEventListener('input', () => {
    if (emailError.style.display === 'block') hideError();
  });

  notifyMeBtn?.addEventListener('click', openDrawer);
  notifyCloseBtn?.addEventListener('click', closeDrawer);
  notifyOverlay?.addEventListener('click', closeDrawer);
  continueBtn?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  function handleVariantChange(data) {
    if (!notifyMeBtn) return;
    const variant = data?.data?.variant;
    console.log('variant', variant, 'available', variant?.available);
    if (!variant) return;

    notifyMeBtn.dataset.variant = JSON.stringify(variant);
    currentVariant = variant;

    if (variant.available) {
      notifyMeBtn.style.display = 'none';
      addtocartbtn.style.display = 'inline-flex';
    } else {
      notifyMeBtn.style.display = 'block';
      addtocartbtn.style.display = 'none';
    }
    if (variant.available && notifyDrawer?.classList.contains('is-open')) {
      closeDrawer();
    }
  }



  // Subscribe to FoxTheme variant change pubsub event
  if (window.FoxTheme?.pubsub) {
    FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
      handleVariantChange
    );
  } else {
    // Fallback: wait for FoxTheme to be ready
    document.addEventListener('foxtheme:ready', () => {
      FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
        handleVariantChange
      );
    });
  }

  submitBtn?.addEventListener('click', async () => {
    const email = emailInput?.value?.trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError();
      emailInput?.focus();
      return;
    }

    hideError();
    submitBtn.textContent = 'Submitting...';
    submitBtn.disabled = true;

    try {
      const formData = new FormData();
      formData.append('sheet_name', 'Notify me '); 
      formData.append('Email', email);
      formData.append('Submitted At', new Date().toISOString());
      formData.append('Product Title', currentVariant?.name || document.querySelector('.product__title')?.textContent?.trim() || '');
      formData.append('Variant', currentVariant?.title || '');


      await fetch(NOTIFY_SHEET_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      });

      emailWrapper.style.display = 'none';
      thankuWrapper.style.display = 'block';

    } catch (err) {
      console.error('Notify Me error:', err);
      submitBtn.textContent = 'Notify Me First';
      submitBtn.disabled = false;
    }
  });
});